
$(document).ready(() => {
  if (jQuery('#slider1').length) {
    var primarySlider = new Splide('#slider1', {
      type: 'fade',
      direction: 'ttb',
      // autoWidth: true,
      width: '630px',
      height: '450px',
      pagination: false,
      arrows: false,
      cover: false,

    });

    var secondSlider = new Splide('#slider2', {
      classes: {
        prev: 'slider-prev-hide',
      },
      direction: 'ttb',
      width: '270px',
      height: '400px',
      perPage: 2,
      pagination: false,
      isNavigation: true,
      focus: 'center',
      cover: true,
      rewind: true,
      gap: '1rem',
      breakpoints: {
        '920': {
          direction: 'ttb',
          perPage: 1,
        },
      },
    }).mount();

    primarySlider.sync(secondSlider).mount();
  }

  if($('.js-deal-carousel').length) {
    var options = {
      autoHeight: true,
      perPage: 3,
      pagination: true,
      isNavigation: false,
      cover: true,
      rewind: true,
      gap: '1rem',
      breakpoints: {
        '920': {
          // direction: 'ttb',
          perPage: 1,
        },
      },
    };

    $('.js-deal-carousel').each(function(){
      new Splide('#' + this.id, options ).mount();
    });
  }
});
